import Axios from "axios";
import React from "react";
import { Redirect } from "react-router-dom";

class Goto extends React.Component
{
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        Axios.get(process.env.PUBLIC_URL + '/data/links.json').then(res => {
            const links = res.data.links;
            var nextUrl = "";

            if(links[this.props.match.params.slug])
            {
                nextUrl = links[this.props.match.params.slug]
            } else {
                switch(this.props.match.params.slug)
                {
                    case 'op-plan':
                        nextUrl = links.opPlan
                        break
                    case 'op-sd':
                        nextUrl = links.opSd
                        break
                    case 'op-personel':
                        nextUrl = links.opPersonel
                        break
                    case 'op-law':
                        nextUrl = links.opLaw
                        break
                    case 'op-gqa':
                        nextUrl = links.opGqa
                        break
                    case 'op-transport':
                        nextUrl = links.opTransport
                        break
                    case 'archive-nsru-v4-website':
                        nextUrl = links.nsruV4
                        break;
                    default:
                        nextUrl = process.env.PUBLIC_URL + "/";
                }
            }

            window.location.replace(nextUrl)
        });
    }

    render() {
        return (
            <>
            </>
        );
    }
}

export default Goto;
